import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  FormsModule,
  Validators,
} from '@angular/forms';
import { Notification } from '../../../models/notification.model';
import { NotificationService } from '../../../services/notification.service';
import { ToastAlertService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatCardModule } from '@angular/material/card';
import { JsonPipe, NgFor } from '@angular/common';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { TextAreaComponent } from '../../../../shared/components/text-area/text-area.component';
import { Building } from '../../../models/building.model';
import { TemplateName } from '../../../models/template-name';

@Component({
  selector: 'editor-page',
  templateUrl: './editor-page.component.html',
  standalone: true,
  imports: [
    ToolbarComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatOptionModule,
    NgFor,
    MatCardModule,
    FormsModule,
    ButtonComponent,
    TextAreaComponent,
    JsonPipe,
  ],
})
export class EditorPageComponent implements OnInit {
  private notificationService = inject(NotificationService);
  private alertService = inject(ToastAlertService);
  private formBuilder = inject(FormBuilder);
  noti: Notification[] = [];
  notificationid: number = 0;

  selected: any;
  selectedValue: any;
  editorContent: any;
  valueSelected: any;
  editorContentNombre: any;
  selectedContent = {
    templateName: '',
    salutation: '',
    messageBody: '',
    subjectMail: '',
  };
  constructor(private el: ElementRef) {}
  public editadoBuilding!: FormGroup;
  selectedControl: FormControl = new FormControl('');

  ngOnInit(): void {
    this.loaderTypeNotification();
    this.buildForm();
    this.update();
  }

  private loaderTypeNotification(loaderSelected = false) {
    this.notificationService.getNotification().subscribe({
      next: resp => {
        if (resp.code === 10000) {
          this.noti = resp.reply || [];
          if (loaderSelected) {
            this.onSelectionChange(this.valueSelected);
          }
        } else {
          this.alertService.error(resp.detail);
        }
      },
    });
  }

  private buildForm(): void {
    this.editadoBuilding = this.formBuilder.group({
      name: [
        this.selectedContent.templateName,
        [Validators.required, Validators.maxLength(256)],
      ],
      salutation: [
        this.selectedContent.salutation,
        [
          Validators.required,
          Validators.maxLength(256),
          Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\\s,.]+$'),
        ],
      ],
      body: [
        this.selectedContent.messageBody,
        [Validators.required, Validators.maxLength(400)],
      ],
      subject: [
        this.selectedContent.subjectMail,
        [
          Validators.required,
          Validators.maxLength(256),
          Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\\s,.]+$'),
        ],
      ],
    });
  }

  onSelectionChange(event: any) {
    this.selectedControl.setValue(event.value);
    this.valueSelected = event;
    const selectedValue = event.value;
    if (selectedValue === 'Ninguna') {
      this.editorContent = '';
      return;
    }
    const selectedOption = this.noti.find(
      item => item.idTemplate === selectedValue
    );

    if (selectedOption) {
      this.notificationid = event.value;
      this.selected = selectedOption.templateName;
      this.editadoBuilding.get('name')?.setValue(selectedOption.templateName);
      this.editadoBuilding
        .get('salutation')
        ?.setValue(selectedOption.salutation);
      this.editadoBuilding.get('body')?.setValue(selectedOption.messageBody);
      this.editadoBuilding.get('subject')?.setValue(selectedOption.subjectMail);
    } else {
      this.editorContent = '';
      this.selected = '';
      this.editadoBuilding.get('name')?.setValue('');
      this.editadoBuilding.get('salutation')?.setValue('');
      this.editadoBuilding.get('body')?.setValue('');
      this.editadoBuilding.get('subject')?.setValue('');
    }
  }

  update() {
    if (this.editadoBuilding.valid) {
      this.notificationService
        .updateNotification(this.editadoBuilding.value, this.notificationid)
        .subscribe({
          next: async resp => {
            if (resp.code === 10000) {
              this.alertService.sucess('Notificación modificada');
              this.loaderTypeNotification(true);
            } else {
              this.alertService.error(resp.detail);
              this.clearForm();
            }
          },
        });
    }
  }

  findData() {}

  clearForm() {
    this.selectedControl.setValue('');
    this.selected = '';
    this.editorContent = '';
    this.editorContent = '';
    this.selected = '';
    this.editadoBuilding.get('name')?.setValue('');
    this.editadoBuilding.get('salutation')?.setValue('');
    this.editadoBuilding.get('body')?.setValue('');
    this.editadoBuilding.get('subject')?.setValue('');
  }
}
